import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from '@/services/axios'
import appConfig from './config/app.config'
import vuetify from './plugins/vuetify'
import logService from '@/services/log.service'

Vue.config.productionTip = false

Vue.use(logService)

Vue.use(VueAnalytics, {
  id: appConfig.trackingGA,
  router,
  ecommerce: {
    enabled: true,
    enhanced: true
  }
})

store.$http = axios

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
